import { useCallback } from 'react';
import { expVal } from '@atlassian/jira-feature-experiments';

interface YellowBrickRoad {
	shouldDisplayMessage: boolean;
	// TODO will be implemented in https://hello.jira.atlassian.cloud/browse/PACK-278
	messageId?: string;
}

export const useYbrFeature = () => {
	const shouldShowYbrMessage = useCallback(({ shouldDisplayMessage }: YellowBrickRoad) => {
		if (!shouldDisplayMessage) {
			return false;
		}

		expVal('jira_ybr_first_batch_aa', 'isYBREnabled', false);
		expVal('jira_ybr_first_batch_both_aa', 'isYBREnabled', false);

		// we should not show the message if the experiment is enabled
		return !expVal('jira_ybr_first_batch', 'isYBREnabled', false);
	}, []);

	const shouldShowYbrMessageForIssueView = useCallback(
		({ shouldDisplayMessage }: YellowBrickRoad) => {
			if (!shouldDisplayMessage) {
				return false;
			}

			expVal('jira_ybr_first_batch_issue_view_aa', 'isYBREnabled', false);
			expVal('jira_ybr_first_batch_both_aa', 'isYBREnabled', false);

			// we should not show the message if the experiment is enabled
			return !expVal('jira_ybr_first_batch', 'isYBREnabled', false);
		},
		[],
	);

	return {
		shouldShowYbrMessage,
		shouldShowYbrMessageForIssueView,
	};
};
